<style lang="scss" scoped>

    $nav-line-height: 58px;
    $nav-brand-height: 48px;
    $nav-list-icon-height: 24px;

    #nav {
        position: fixed !important;
        padding-right: 30px;
        height: $nav-line-height;
        line-height: $nav-line-height;
        border-bottom: 1px solid rgba(0, 0, 0, .08);
        background: rgba(255, 255, 255, .97);
    }

    ul {
        float: right;
        font-size: 16px;
        height: $nav-line-height;
        margin-top: 0;
        li {

            height: 100%;
            margin-left: 20px;
            list-style: none;
            text-align: center;
            display: inline-block;
            a {
                height: 100%;
                text-decoration: none;
                color: inherit;
                display: flex;
                align-items: center;
                &:before {
                    content: "";
                    display: inline-block;
                    width: $nav-list-icon-height;
                    height: $nav-list-icon-height;
                    margin-right: 5px;
                }
            }
        }
    }

    #website-brand {
        margin-top: ($nav-line-height - $nav-brand-height) / 2;
        width: $nav-brand-height;
        height: $nav-brand-height;
        margin-left: 20px;
    }

    .search:before {
        background: url("../../../../images/search.svg") no-repeat center;
    }

    .good:before {
        background: url("../../../../images/good.svg") no-repeat center;
    }

    .insurance:before {
        background: url("../../../../images/insurance.svg") no-repeat center;
    }

    .me:before {
        background: url("../../../../images/me.svg") no-repeat center;
    }

    .old:before {
        background: url("../../../../images/old.svg") no-repeat center;
    }

</style>

<template>
    <headroom :zIndex="500" :offset="58" id="nav">
        <img class="animated flip" id="website-brand" src="/images/bruceit.png" alt="bruceit.com">
        <ul>
            <li><a class="search" href="/search">搜索</a></li>
            <li><a class="good" target="_blank" href="/skills">技能图谱</a></li>
            <li><a class="insurance" target="_blank" href="https://cps.qixin18.com/m/hx1057397/media-32744.html">保险配置[🔥返佣]</a></li>
            <li><a class="me" href="/about">关于我</a></li>
        </ul>
    </headroom>
</template>

<script>
    import {headroom} from 'vue-headroom';

    export default {
        components: {
            headroom
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/index/nav.vue